export default "__VITE_ASSET__DcCHW1$2__"